import client from '@/services/network/http'

class SettingBaseApi {
  async post<T>(url: string, data?: object) {
    return client.post<T>('/log' + url, { bizContent: data })
  }
}

export default SettingBaseApi
